import { isLoyaltyCardCode } from '@360face/domain';

/**
 * QR scanner built into the kiosk stand (owner decision 14.10.2026). Such scanners act as a
 * keyboard: they "type" the code very fast and press Enter. A person types much slower, so
 * keys that come in a fast burst ending with Enter and forming a card code are a scan.
 */
export interface ScanBuffer {
  /** Feed one key. Returns the card code when a scan has just finished. */
  push(key: string, at: number): { code?: string; started?: boolean };
}

export function createScanBuffer(maxGapMs = 60): ScanBuffer {
  let buf = '';
  let last = -Infinity;
  return {
    push(key, at) {
      if (at - last > maxGapMs) buf = '';
      last = at;
      if (key === 'Enter') {
        const code = buf.trim().toUpperCase();
        buf = '';
        return isLoyaltyCardCode(code) ? { code } : {};
      }
      if (key.length !== 1) return {};
      buf += key;
      return { started: buf.length === 1 };
    },
  };
}
